<template>
  <v-navigation-drawer
    v-model="$store.state.navigation.menuVisible"
    :permanent="$vuetify.breakpoint.lgAndUp"
    clipped
    app
    floating
    width="292"
    class="nav-container"
  >
    <div class="hidden-lg-and-up spacer" />
    <div class="heading text-uppercase">
      {{ $t('general.device.plural') }}
    </div>
    <v-list>
      <v-list-tile
        v-for="device in devices"
        :key="device.id"
        ripple
        :to="device.route"
      >
        <v-list-tile-content>
          <v-list-tile-title>{{ device.name }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'DeviceDrawer',
  props: {
    devices: {
      default() {
        return [];
      },
      type: Array,
    },
  },
};
</script>

<style scoped>
.spacer {
  padding-top: 2rem;
}

.nav-container {
  padding-left: 70px;
  padding-right: 16px;
  color: #949CB2;
}

.heading {
  font-size: 14px;
}
</style>

<style>
.v-list__tile--active {
  background-color: #eaf1fe;
}

.v-list__tile {
  color: #949CB2;
  border-radius: 10px;
}
</style>
